module.exports = __webpack_public_path__ + "static/media/profile_icon_no_bg.80168b4b.png";